import { Controller } from "@hotwired/stimulus"

// Filters the brand-playground pose checkboxes down to the ones whose
// audience matches the selected model's age group. Poses tagged "all"
// always show. Hidden poses get unchecked so they can't be submitted.
export default class extends Controller {
  static targets = ["model", "pose", "empty"]

  connect() {
    this.filter()
  }

  filter() {
    const group = this.selectedAgeGroup()
    let visible = 0

    this.poseTargets.forEach((el) => {
      const audience = el.dataset.poseAudience || "all"
      const show = !group || audience === "all" || audience === group
      el.style.display = show ? "" : "none"
      if (show) {
        visible += 1
      } else {
        const cb = el.querySelector("input[type=checkbox]")
        if (cb) cb.checked = false
      }
    })

    if (this.hasEmptyTarget) {
      this.emptyTarget.style.display = visible === 0 ? "" : "none"
    }
  }

  selectedAgeGroup() {
    if (!this.hasModelTarget) return null
    const opt = this.modelTarget.options[this.modelTarget.selectedIndex]
    return opt ? opt.dataset.ageGroup : null
  }
}
